<template>
  <div class="accordion">
    <div class="accordion-item" v-for="(item, i) in content" :key="`item${i}`">
      <div
        class="accordion-title accordion-toggle"
        @click="toggle(i)"
        v-html="item.title"
        :class="{ rotate: show(i) }"
        ref="accordion"
      ></div>

        <div class="accordion-content" v-html="item.content" v-show="show(i)" ref="acc"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: ['content'],

  data () {
    return {
      active: -1
    }
  },

  methods: {
    show (i) {
      return this.active === i
    },

    toggle (i) {
      this.active = this.active === i ? -1 : i
      setTimeout(() => {
        window.scrollTo(0, this.$refs.accordion[i].offsetTop - 110)
      }, 50)
    },

    beforeEnter (el) {
      el.style.height = '0'
    },

    enter (el) {
      el.style.height = el.scrollHeight + 'px'
    },

    beforeLeave (el) {
      el.style.height = el.scrollHeight + 'px'
    },

    leave (el) {
      el.style.height = '0'
    }
  }
}
</script>
